import { Text } from '@components/ui/typography';
import { spacingBottomM } from '@components/_blog-detail/spacings';
import { parse } from '@config/theme';
import { decodeAssetId } from '@lib/sanity/decode-asset-id';
import { blurImage, urlFor } from '@lib/sanity/url-for';
import { cx } from '@linaria/core';
import Image from 'next/image';
import React, { FC } from 'react';
import { CbSingleImage as CbSingleImageModel } from '__generated__/sanity';
export const CbSingleImage: FC<CbSingleImageModel> = ({
  image,
  caption,
  width,
  background
}) => {
  const {
    dimensions
  } = decodeAssetId(image.asset._ref);
  return <div className={cx(spacingBottomM, background === 'grey' && bgGrey)}>
      <figure className={figure} data-width={width}>
        <Image className={img} src={urlFor(image).toString()} blurDataURL={blurImage(image)} placeholder="blur" layout="responsive" alt={image.alt} {...dimensions} />
        {caption && <Text variant="bodyRegular" color="shade500" mt="4" as="figcaption">
            {caption}
          </Text>}
      </figure>
    </div>;
};
const figure = parse({
  mx: 'auto'
}, "fjtveud");
const bgGrey = parse({
  pt: '64',
  pb: '64',
  bg: 'shade300'
});
const img = "i1sxu5ll";

require("./index.linaria.module.css!=!../../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");